import Lottie from 'lottie-react';

import value from '../jsons/Value.json';

const Value = props => {
  return <Lottie animationData={value} {...props} />;
};

export default Value;
